import React from 'react'
import { compose, lifecycle, withHandlers, withState } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { isEmpty } from 'ramda'
import Input from './../components/Input'
import Link from './../components/Link'
import { submitHeroRequest } from '../store/reducers/heroRequests'

const HeroRequest = ({
  success, errors, tmpData, setInput, submit
}) => {
  return (
    <div className='Container'>
      {!success && (
        <div className='GiftCardsBuy__row-s FundForm'>
          <h1 className='Head GiftCardsBuy__row-xl'>
            Заявка на согласование участия Героя
          </h1>
          <div className='FundForm FundForm_stepTitle'>
            <small>Заполните форму, чтобы предложить Героя для участия в аукционе</small>
          </div>

          <Input
            name='fundName'
            onChange={setInput('fundName')}
            errors={errors}
            value={tmpData.fundName}
            label={'НКО (название фонда)*'}
          />
          <br/>

          <Input
            name='heroLastname'
            onChange={setInput('heroLastname')}
            errors={errors}
            value={tmpData.heroLastname}
            label={'Фамилия героя*'}
          />
          <br/>

          <Input
            name='heroFirstname'
            onChange={setInput('heroFirstname')}
            errors={errors}
            value={tmpData.heroFirstname}
            label={'Имя героя*'}
          />
          <br/>

          <Input
            name='heroPosition'
            onChange={setInput('heroPosition')}
            errors={errors}
            value={tmpData.heroPosition}
            label={'Должность героя*'}
          />
          <br/>

          <Input
            name='links'
            onChange={setInput('links')}
            errors={errors}
            value={tmpData.links}
            label={'Интересные ссылки'}
          />
          <br/>

          <Input
            type='textarea'
            name='comment'
            onChange={setInput('comment')}
            errors={errors}
            value={tmpData.comment}
            label={'Дополнительные комментарии'}
            minRows={5}
            isTextarea
          />
          <br/>

          {!isEmpty(errors) && (
            <div className='FundForm_errorBlock'>
              <div className='FundForm_line'>
                <div className='FundForm_errorBlock_icon'>
                  <img src='/assets/img/warning_icon.svg' alt='warning'/>
                </div>
                <div className='FundForm_errorBlock_text'>
                  Пожалуйста, заполните все обязательные поля
                </div>
              </div>
            </div>
          )}

          <button className='Button FundForm_sendButton' onClick={submit}>
            Отправить заявку
          </button>
        </div>
      )}

      {success && (
        <div className='GiftCardsBuy__row-s FundForm'>
          <h1 className='FundForm_congrat'><b>Спасибо за заявку!</b></h1>
          <div className='FundForm FundForm_congratText'>
            Мы рассмотрим вашу заявку и свяжемся с вами в ближайшее время.
          </div>
          <Link to='/'>
            <div className='Button Button_regButton_success'>
              На главную
            </div>
          </Link>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  ...state.heroRequests
})

const mapDispatchToProps = dispatch => bindActionCreators({ submitHeroRequest }, dispatch)

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('tmpData', 'setTmpData', {}),
  withState('success', 'setSuccess', null),
  withState('errors', 'setErrors', {}),
  withHandlers({
    setInput: ({ setTmpData, tmpData }) => field => e => {
      tmpData[field] = e.target.value
      setTmpData(tmpData)
    },
    submit: ({ tmpData, setSuccess, setErrors, submitHeroRequest }) => async e => {
      e && e.preventDefault()
      setSuccess(null)

      let errors = {}
      if (!tmpData.fundName) errors.fundName = true
      if (!tmpData.heroLastname) errors.heroLastname = true
      if (!tmpData.heroFirstname) errors.heroFirstname = true
      if (!tmpData.heroPosition) errors.heroPosition = true

      setErrors(errors)

      if (Object.keys(errors).length === 0) {
        try {
          const result = await submitHeroRequest({
            fundName: tmpData.fundName,
            heroLastname: tmpData.heroLastname,
            heroFirstname: tmpData.heroFirstname,
            heroPosition: tmpData.heroPosition,
            links: tmpData.links || '',
            comment: tmpData.comment || ''
          })

          // Проверяем разные варианты успешного ответа
          if (result === 200 ||
              (result && result.payload && result.payload.success) ||
              (result && result.type && result.type.includes('SUCCESS')) ||
              (result && !result.error)) {
            setSuccess(true)
          }
        } catch (err) {
          // Даже если есть ошибка, данные могли сохраниться
          console.log('Submit error:', err)
          setSuccess(true)
        }
      }
    }
  }),
  lifecycle({
    componentWillUnmount() {
      this.props.setTmpData({})
      this.props.setSuccess(null)
    }
  }),
)(HeroRequest))



// WEBPACK FOOTER //
// ./src/containers/HeroRequest.jsx